import { api } from './api'
import { LoginCredentials, AuthTokens, User, UserCreate } from '@/types'

export const authApi = {
  login: async (credentials: LoginCredentials): Promise<AuthTokens & { user: User }> => {
    const formData = new URLSearchParams()
    formData.append('username', credentials.email)
    formData.append('password', credentials.password)
    
    return api.post('/auth/login', formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    })
  },
  
  loginJson: async (credentials: LoginCredentials): Promise<AuthTokens & { user: User }> => {
    return api.post('/auth/login/json', credentials)
  },
  
  register: async (data: UserCreate): Promise<User> => {
    return api.post('/auth/register', data)
  },
  
  refreshToken: async (refreshToken: string): Promise<{ access_token: string; refresh_token: string }> => {
    return api.post('/auth/refresh', { refresh_token: refreshToken })
  },
  
  getCurrentUser: async (): Promise<User> => {
    return api.get('/auth/me')
  },

  updateProfile: async (updates: Partial<Pick<User, 'first_name' | 'last_name' | 'phone' | 'cedula_profesional' | 'especialidad'>>): Promise<User> => {
    return api.patch('/auth/me', updates)
  },
  
  changePassword: async (currentPassword: string, newPassword: string): Promise<void> => {
    return api.post('/auth/password/change', {
      current_password: currentPassword,
      new_password: newPassword,
    })
  },

  requestCredentialReset: async (identifier: string): Promise<{ message: string }> => {
    return api.post('/auth/password/reset-request', { identifier })
  },
}
